<template>
    <section class="contact-section">
        <div class="section-header">
            <p class="section-kicker">Get in Touch</p>
            <h2>Contact Us</h2>
            <p>
                Contact us today to schedule a tour, learn about membership options, or book your first tennis session.
            </p>
        </div>

        <div class="contact-grid">
            <div class="info-panel">
                <h3>Visit Our Club</h3>

                <article class="contact-info">
                    <span><MailCheck /></span>
                    <div>
                        <h4>Give us a call</h4>
                        <p>Phone: <a :href="'tel:' + dataList.phone">{{ dataList.phone }}</a></p>
                    </div>
                </article>

                <article class="contact-info">
                    <span><PhoneOutgoing /></span>
                    <div>
                        <h4>Send us an email</h4>
                        <p>Email: <a :href="'mailto:' + dataList.email">{{ dataList.email }}</a></p>
                    </div>
                </article>

                <article class="contact-info">
                    <span><MapPin /></span>
                    <div>
                        <h4>Visit us</h4>
                        <p>{{ dataList.address }}</p>
                    </div>
                </article>
            </div>

            <div class="form-panel">
                <h3>Send us a message</h3>
                <form class="contact-form" @submit.prevent="submitForm">
                    <div class="name-email">
                        <div class="form-group">
                            <label for="fullName">Full Name</label>
                            <input v-model="fullname" type="text" id="fullName" placeholder="Enter your full name" required />
                        </div>
                        <div class="form-group">
                            <label for="email">Email</label>
                            <input v-model="email" type="email" id="email" placeholder="Enter your email" required />
                        </div>
                    </div>

                    <div class="name-email">
                        <div class="form-group">
                            <label for="phone">Phone Number</label>
                            <input v-model="phone" type="tel" id="phone" placeholder="Enter your phone number" required />
                        </div>
                        <div class="form-group">
                            <label for="subject">Subject</label>
                            <input v-model="subject" type="text" id="subject" placeholder="Enter subject" required />
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="message">Message</label>
                        <textarea v-model="message" id="message" rows="8" placeholder="Write your message..." required></textarea>
                    </div>

                    <button type="submit" class="submit-btn">
                        <span>Send Message</span>
                        <ChevronRight />
                    </button>
                </form>
            </div>
        </div>
    </section>
</template>

<script setup>
/* eslint-disable */
import { MailCheck, PhoneOutgoing, MapPin, ChevronRight } from "lucide-vue-next";
import { ref, onMounted } from "vue";
import axios from 'axios';

const dataList = ref({});
const fullname = ref('');
const email = ref('');
const phone = ref('');
const subject = ref('');
const message = ref('');

onMounted(async () => {
  await listLogo();
});

const listLogo = async () => {
  try {
    const response = await axios.get('/logo_lists.php');
    dataList.value = response.data.data[0] || {};
  } catch (error) {
    console.error(error.message);
  }
};

async function submitForm() {
    if (!fullname.value || !email.value || !phone.value || !subject.value || !message.value) {
        alert("Please fill in all fields.");
        return;
    }

    const formData = new FormData();
    formData.append("fullname", fullname.value);
    formData.append("email", email.value);
    formData.append("phone", phone.value);
    formData.append("subject", subject.value);
    formData.append("message", message.value);

    try {
        const response = await axios.post("/about_contactus.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });

        alert(response.data.message);

        fullname.value = "";
        email.value = "";
        phone.value = "";
        message.value = "";
        subject.value = "";
    } catch (error) {
        console.error(error);
        alert(error.response ? error.response.data.message : error.message);
    }
}
</script>

<style scoped lang="scss">
.contact-section {
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    padding: 40px;
    border-radius: 28px;
    background: linear-gradient(180deg, #fffaf8 0%, #ffffff 100%);
    border: 1px solid #f0e5e1;
}

.section-header {
    text-align: center;
    margin-bottom: 28px;
}

.section-kicker {
    margin: 0 0 10px;
    color: #0f5b2b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.section-header h2 {
    margin: 0;
    font-size: clamp(28px, 3vw, 44px);
    font-weight: 700;
    color: #0f172a;
}

.section-header p {
    margin: 10px auto 0;
    max-width: 760px;
    color: #64748b;
    font-size: 16px;
    line-height: 1.7;
}

.contact-grid {
    display: grid;
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    gap: 28px;
}

.info-panel,
.form-panel {
    border: 1px solid #e9edf3;
    border-radius: 24px;
    background: #fff;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
    padding: 28px;
}

.info-panel h3,
.form-panel h3 {
    margin: 0 0 20px;
    font-size: 24px;
    font-weight: 700;
    color: #0f172a;
}

.contact-info {
    display: flex;
    gap: 18px;
    align-items: flex-start;
    padding: 18px;
    border-radius: 18px;
    background: #f8fafc;
    border: 1px solid #e5edf5;
    margin-bottom: 14px;
}

.contact-info span {
    width: 52px;
    height: 52px;
    min-width: 52px;
    border-radius: 50%;
    border: 1px solid #d6e2db;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ed4e24;
    background: #fff;
}

.contact-info h4 {
    margin: 0 0 6px;
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
}

.contact-info p {
    margin: 0;
    color: #475569;
    font-size: 14px;
    line-height: 1.65;
    text-align: left;
}

.contact-info a {
    color: inherit;
    text-decoration: none;
}

.contact-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.name-email {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

label {
    font-size: 14px;
    font-weight: 600;
    color: #0f172a;
}

input,
textarea {
    width: 100%;
    border: 1px solid #cbd5e1;
    border-radius: 12px;
    padding: 14px 16px;
    font-size: 15px;
    background: #fff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

input:focus,
textarea:focus {
    outline: none;
    border-color: #0f5b2b;
    box-shadow: 0 0 0 4px rgba(15, 91, 43, 0.08);
}

.submit-btn {
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    border: none;
    border-radius: 999px;
    padding: 14px 22px;
    background: #ed4e24;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 12px 28px rgba(237, 78, 36, 0.24);
}

@media (max-width: 992px) {
    .contact-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .contact-section {
        padding: 24px 16px;
        border-radius: 22px;
    }

    .name-email {
        grid-template-columns: 1fr;
    }

    .submit-btn {
        width: 100%;
        justify-content: center;
    }
}
</style>
